import React from 'react'

function PreTaxDec() {
  return (
    <head style={{all:'initial'}}>
                <title>محاسب ضريبة القيمة المضافة الرياض</title>
                <meta name="description" content="تسجيل ضريبة القيمة المضافة"/>
                <meta name="keywords" content="محاسب ضريبة القيمة المضافة الرياض , تسجيل ضريبة القيمة المضافة" />
            </head>
  )
}

export default PreTaxDec